import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTradeAgreementSellOutValidatorRequest } from '../redux-saga/actions/addTradeAgreementSellOutValidator';
import { deleteTradeAgreementSellOutValidatorRequest } from '../redux-saga/actions/deleteTradeAgreementSellOutValidator';
import { validatorsListTradeAgreementSellOutRequest } from '../redux-saga/actions/validatorList';
import { ValidatorsListView } from './ValidatorsListView';
import { DeleteValidatorModal } from './DeleteValidatorModal';
import { ValidatorsScopeWrapper } from './ValidatorSScopeWrapper';
import { tradeAgreementsSellOutValidatorsCatalogRequest } from 'RootModule/redux/actions/tradeAgreementsSellOutValidators';
import { daysLeftRequest } from '../redux-saga/actions/daysLeft';
import { useValidatorsReduceList } from '../hooks/useValidatorsReduceList';
import { useValidatorsParams } from '../hooks/useValidatorsParams';

export const SellOutList = () => {
  const dispatch = useDispatch();
  const clientId = useSelector((state) => state?.VALIDATIONS?.filters?.query?.clientId ?? []);
  const territoryId = useSelector((state) => state?.VALIDATIONS?.filters?.query?.territoryId ?? []);
  const daysLeft = useSelector((state) => state?.VALIDATIONS?.daysLeft?.total ?? 0);
  const agreementValidatorListLoading = useSelector(
    (state) => state?.VALIDATIONS?.deleteTradeAgreementSellOutValidator?.loading || false
  );
  const options = useSelector(
    (state) =>
      state?.APP?.tradeAgreementsSellOutValidatorsCatalog?.tradeAgreementsSellOutValidators?.data ??
      []
  );
  const list = useSelector(
    (state) => state?.VALIDATIONS?.validatorList?.tradeAgreementSellOut?.list || []
  );

  const [selectedUser, setSelectedUser] = useState('');
  const [selectedOption, setSelectedOption] = useState([]);
  const [validatorsToDisable, setValidatorsToDisable] = useState([]);
  const [deletionModal, setDeletionModal] = useState({ visible: false, user: {} });
  const [dropdownLength, setDropdownLength] = useState(0);
  const selected = useRef('');
  const { getAddTradeAgreementsParams, getDeleteTradeAgreementsParams } = useValidatorsParams();

  const callTradeAgreementSellOutList = () => {
    const params = { Territories: [territoryId], clients: clientId };
    dispatch(validatorsListTradeAgreementSellOutRequest({ params }));
  };

  const reducedList = useValidatorsReduceList(list);

  const canModifyTradeAgreement = typeof territoryId === 'number' && clientId.length > 0;
  const canModify = canModifyTradeAgreement && !agreementValidatorListLoading && daysLeft > 0;
  const modalOptions = deletionModal.user?.clients;
  const moduleTitle = 'Acuerdo Comercial Sell Out';

  useEffect(() => {
    const canMod = !Array.isArray(territoryId) && clientId.length > 0;
    if (canMod) callTradeAgreementSellOutList();
    if (typeof territoryId === 'number') {
      let params = {
        Clients: clientId,
        Territories: [territoryId],
      };
      dispatch(tradeAgreementsSellOutValidatorsCatalogRequest({ params }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [territoryId, clientId]);

  useEffect(() => {
    dispatch(daysLeftRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddTradeAgreementSellOutValidator = (id) => {
    const params = getAddTradeAgreementsParams({ id, clientId, territoryId });
    dispatch(addTradeAgreementSellOutValidatorRequest({ params }));
  };
  const handleDeleteTradeAgreementSelloutValidator = () => {
    const params = getDeleteTradeAgreementsParams({
      validatorsToDisable,
      selectedUser,
      territoryId,
    });
    dispatch(deleteTradeAgreementSellOutValidatorRequest({ params }));
  };

  const handleSelectedValidatorToDisable = (item) => {
    const { clients } = item;
    setValidatorsToDisable(clients.map((client) => client.clientId));
  };

  const handleSelect = (value) => {
    selected.current = value.map((item) => JSON.parse(item).userId);
    setDropdownLength(value.length);
    setSelectedOption(value);
  };

  const hasAprovedSalesChallenges = (item) => {
    return item.territories.some(({ hasApprovedChallenge }) => hasApprovedChallenge === false);
  };

  const validatorScopeWrapper = (item) => <ValidatorsScopeWrapper data={item.clients} />;
  const delValidatorModal = () => (
    <DeleteValidatorModal
      deletionModal={deletionModal}
      validatorsToDisable={validatorsToDisable}
      moduleTitle={moduleTitle}
      onCancel={() => setDeletionModal({ visible: false, user: {} })}
      onOk={() => {
        handleDeleteTradeAgreementSelloutValidator();
        setDeletionModal({ visible: false, user: {} });
      }}
      onChange={(value) => setValidatorsToDisable(value)}
      modalOptions={modalOptions?.map((item) => ({ id: item.clientId, name: item.name }))}
    />
  );

  return (
    <ValidatorsListView
      moduleTitle={moduleTitle}
      canModify={canModify}
      handleSelect={handleSelect}
      selectedOption={selectedOption}
      options={options}
      dropdownLength={dropdownLength}
      handleSelectedValidatorToDisable={handleSelectedValidatorToDisable}
      handleAddValidator={handleAddTradeAgreementSellOutValidator}
      validatorScopeWrapper={validatorScopeWrapper}
      selected={selected}
      setSelectedOption={setSelectedOption}
      reducedList={reducedList}
      hasAproved={hasAprovedSalesChallenges}
      setSelectedUser={setSelectedUser}
      setDeletionModal={setDeletionModal}
      delValidatorModal={delValidatorModal}
    />
  );
};
